<template>
	<div class="employerJobDetails" v-loading="modalDataLoad">
		<div class="o-main-content-area o-main-content-area--padBotoomNone" v-if="job">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-6">
                    <h1 class="h1">Jobs / Events: <span>{{job?job.title:'--'}}</span></h1>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li v-if="job && job.client && job.client.employer && job.client.employer[0].status && job.client.employer[0].status.name !='View Access'">
                            <a href="javascript: void(0)" @click="openEditJob()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</a>
                        </li>
                        <li v-if="deleteAccess()"><a @click="deleteJob()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Job</a></li>
                    </ul>
                </div>
            </div>

            <div class="c-common-space c-common-space--overflowVisible clearfix c-responsive-fixwidth">
                <div class="col-md-9 o-no-padding">
                    <div class="custom-row">    
                        <div class="custom-col text-left">
                            <ul class="o-custom-filter">
                                <li>
                                    <span class="o-blue-medium-text">Job Number:</span> 
                                    <span>#{{ job && job.job_number ? job.job_number : '--' }}</span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">Start Date:</span> 
                                    <span>{{ getDate(job.start) }}</span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">End Date:</span> 
                                    <span>{{ getDate(job.end) }}</span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">Steward:</span> 
                                    <span>
                                        {{ job.employee && job.employee.employable ? job.employee.employable.first_name + ' ' + job.employee.employable.last_name : '--'}}
                                    </span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">Dispatched by:</span> 
                                    <span>
                                        {{ job.dispatched_by ? job.dispatched_by.first_name + ' ' + job.dispatched_by.last_name : '--'}}
                                    </span>
                                </li> 
                            </ul>
                        </div>
                        <div class="custom-col outer--border text-left">
                            <ul class="o-custom-filter">
                                <li>
                                    <span class="o-blue-medium-text">Employer:</span> 
                                    <span>{{(job.employer)?job.employer.name:"NA"}}</span>
                                </li>
	                            <li>
                                    <span class="o-blue-medium-text">Employer Contact:</span> 
                                    <span>{{ displayEmployerContact(job) }}</span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">Payroll:</span> 
                                    <span>{{(job.payroll) ? job.payroll.name : "NA"}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="custom-col outer--border text-left">
                            <ul class="o-custom-filter">
                                <li>
                                    <span class="o-blue-medium-text">Global Skills</span>
                                </li>
                                <li>
                                    <span class="">1. </span>
                                    <span>{{ job.skill1 && job.skill1.name ? job.skill1.name : "NA" }}</span>
                                </li>
	                           
	                            <li>
                                    <span class="">2. </span> 
                                    <span>{{ job.skill2 && job.skill2.name ? job.skill2.name : "NA" }}</span>
                                </li>
	                            <li>
                                    <span class="">3. </span>
                                    <span>{{ job.skill3 && job.skill3.name ? job.skill3.name : "NA" }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="custom-col text-left">
                            <ul class="o-custom-filter">
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                        <div class="custom-col text-left">
                            <ul class="o-custom-filter">
                                <li>
                                    <span class="o-blue-medium-text">Created by:</span> 
                                    <span>
                                        {{job.created_by?job.created_by.first_name+' '+job.created_by.last_name:'--'}} 
                                    </span>
                                    <br />
                                    <span>
                                        {{ getUserDateTimeFormat(job.created_at) }}
                                    </span>
                                </li>
                                <li>
                                    <span class="o-blue-medium-text">Updated by:</span> 
                                    <span>
                                        {{job.updated_by?job.updated_by.first_name+' '+job.updated_by.last_name:'--'}} 
                                    </span>
                                    <br />
                                    <span>
                                        {{ getUserDateTimeFormat(job.updated_at) }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="custom-col text-center"></div>
                    </div>
                </div>
            </div>
            <div class="o-ndividualArea">
                <div class="o-ndividualTable o-ndividualTable--small o-hidden-flow">
                    <div class="col-md-12 text-left o-no-padding">
                        <ul class="o-filter-area">
                            <li><a href="javascript: void(0)" @click="goToCalls()" class="c-common-btn c-common-btn--small"><i class="fa fa-eye" aria-hidden="true"></i> View Calls</a></li>
                            
                            <li><a href="javascript: void(0)" @click="goSignInSheet()" class="c-common-btn c-common-btn--small"><i class="fa fa-address-card-o" aria-hidden="true"></i> Sign In Sheet</a></li>
                            <li><a href="javascript: void(0)" @click="gcsSignInSheet()" class="c-common-btn c-common-btn--small"><i class="fa fa-address-card-o" aria-hidden="true"></i> New Sheet</a></li>
                            <li><a href="javascript: void(0)" @click="employeeDownload()" class="c-common-btn c-common-btn--small"><i class="fa fa-download" aria-hidden="true"></i> Employee Data (.csv)</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="c-common-space c-common-space--overflowVisible clearfix c-responsive-fixwidth">
                <div class="col-md-6">
                    <div class="custom-row u-common-box-shadow c-radius3">
                        <div class="o-issues-table-row">
                            <div class="calls-table-row">
                                <div class="calls-table-cell table-td-border-right o-no-padding">
                                    <div class="u-pad-all-20 c-bg-white">
                                        <div class="calls-table-cell-inner-table c-employee">
                                            <div class="c-issue--column text-center">
                                                <div :class="(job && (job.unassigned_calls_count > 0 || job.unconfirmed_calls_count > 0))?'c-issue-counter' :(job && job.calls.length == 0)?'c-issue-counter':'c-issue-counter o-issue-counter-green'"><i :class="(job && (job.unassigned_calls_count > 0 || job.unconfirmed_calls_count > 0))?'fa fa-thumbs-down':(job && job.calls == 0)?'fa fa-thumbs-down':'fa fa-thumbs-up'" aria-hidden="true"></i><span class="o-issue-couter-sign">{{(job && (job.unassigned_calls_count > 0)) ? job.unassigned_calls_count : 0 + (job && job.unconfirmed_calls_count > 0) ? job.unconfirmed_calls_count : 0}}</span></div>
                                                <div class="c-issue-counter-details u-pad-top-10">Issues require
                                                    <br />attention</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell text-left o-no-padding c-bg-blue">
                                    <div class="u-pad-all-10">
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                <div class="o-issue-counter-small">{{(job && (job.unassigned_calls_count > 0)) ? job.unassigned_calls_count : 0 }}</div>
                                            </div>
                                            <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                <div class="o-issue-desc-small">Calls have
                                                    <br />no employee assigned.</div>
                                            </div>

                                        </div>
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                <div class="o-issue-counter-small">{{(job && (job.unconfirmed_calls_count > 0)) ? job.unconfirmed_calls_count : 0}}</div>
                                            </div>
                                            <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                <div class="o-issue-desc-small">Assignments are
                                                    <br />unconfirmed.</div>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="custom-row u-common-box-shadow c-radius3">
                        <div class="o-calls-table">
                            <div class="o-common-head">
                                <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> Venue: {{job && job.venue ? job.venue.name : 'NA' }}
                                <span v-if="job.venue&&job.venue.addresses&&job.venue.addresses.length">
                                {{ ', ' + job.venue.addresses[0].address+', '+job.venue.addresses[0].municipality+', '+job.venue.addresses[0].state_province+', '+job.venue.addresses[0].country+', '+job.venue.addresses[0].postcode}}</span></h5>
                            </div>
                            <div class="o-map-conatiner googleMap">
                                <iframe 
									width="100%"
									height="100%"
									frameborder="0" style="border:0"
									:src="getMapUrl()" allowfullscreen>
								</iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

          	<div class="col-sm-12 o-no-padding">
	            <div class="col-sm-6 o-right-padding-only o-margin-bottom-20">
	              <div class="col-md-12 o-no-padding">
	                  <h5 class="h2">Employer Request:</h5>
	              </div>
	              <div class="col-md-12 o-no-padding">
	                <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3 clearfix o-skillset-area c-emp-req-text">
                        <div id="add-call" class="word-break">
                            <span class="ps1" v-if="job" v-html="job.employer_requests"></span>
                        </div>
	                </div>
	              </div>
	            </div>

	            <div class="col-sm-6 o-left-padding-only o-margin-bottom-20">
	              <div class="col-md-12 o-no-padding">
	                <h5 class="h2">Documents:</h5>
	              </div>
                  <div v-if="attachmentList.length>0" class="col-md-12">
                    <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3 no-margin-top">
                        <ul class="o-documents-container">
                            <li v-for="(attachment, key, index) in attachmentList" :key="index">
                                <div class="col-md-4 o-no-padding o-uploaded-doc">
                                    <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{snippet(attachment.filename)}}
                                </div>
                                <div class="col-md-8 o-no-padding text-right o-uploaded-doc-owner">
                                   <div class="o-inlineblock o-attachmentdate">
                                        <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(job.attachments[key].created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(job.attachments[key].created_at)}}
                                    </div>
                                    <div class="o-inlineblock text-right">
                                        <h5>
                                            Created by: {{ getNoteAuthor(attachment) }} <a href="javascript: void(0)" @click="deleteAtteachment(attachment.id)" v-show="(getNoteAuthor(attachment)!='Me')? false:true"><i v-show="(getNoteAuthor(attachment)!='Me')? false:true" class="fa fa-trash-o" aria-hidden="true"></i></a>
                                            <a href="javascript: void(0)" @click="show(0 , key, attachment.filename, attachment.path)" class="o-files-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                            <a :class="'files'+index+key" download class="o-files-download" :href="globalBaseUrl + 'auth/'+ decodeFileId(attachment.id)+'/download'"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                                        </h5>
                                        <div :class="'images0'+key" v-viewer="{movable: true}">
                                          <img :src="attachment.path" :key="attachment.path" v-show="false">
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                  </div>
            
                  <div v-if="attachmentList.length == 0" class="col-md-12 o-no-padding">
                    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3 clearfix o-skillset-area c-emp-req-text">
                      <p class="ps1">No Document uploaded</p>
                    </div>
                  </div>
	            </div>
          	</div>
        </div>
        <modal name="add-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom">
          <div tabindex="-1" role="dialog">
            <div role="document">
              <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center modal-header--heading">
                    <button type="button" @click="closeAddJob()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <h1 class="modal-title">{{modalType=='add'?'Add New Job':'Edit Job'}}</h1>
                </div>
                <div v-loading="modalLoading" class="modal-body c-common-box-shadow o-modal-body">

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Event Name:<span class="req-text">*</span></label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input v-model="addJob.title" v-validate="'required'" name="event name" type="text" class="form-control" placeholder="Event Name">
                                    <span class="err-msg">{{ errors.first('event name') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Client:<span class="req-text">*</span></label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <div class="row">
                                    <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                            <select v-validate="'required'" name="employer" class="form-control" v-model="addJob.client" :disabled="modalType=='edit'" @change="getDropdownVenues()">
                                                <option value="">--- Select ---</option>
                                                <option v-for="(client,index) in clients" :key="index" :value="client.client_id" :disabled="client.can_create_job !== true">{{client.client.subdomain.toUpperCase()}} </option>
                                            </select>
                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            <span class="err-msg">{{ errors.first('employer') }}</span>

                                        </div>
                                    </div>
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                    </div>
                                    <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                            <select class="form-control" v-model="addJob.payroll">
                                                <option value="">--- Select ---</option>
                                            </select>
                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Employer Contact:<span class="req-text">*</span></label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <div class="common-label-input--modalwidth o-custom-dropdown">
                                <select class="form-control" v-model="addJob.employer_contact" name="employer contact">
                                    <option value="" disabled>Select Employer Contact</option>
                                    <option v-for="(user,idx) in employer_users" :key="idx" :value="user.user_id"> {{ getEmployerFullName(user.user) }}</option>
                                </select>
                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                            </div>
                            
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Venue:<span class="req-text">*</span></label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                              <div class="common-label-input--modalwidth o-custom-dropdown">
                                <el-select v-model="addJob.venue" filterable placeholder="Select Venue" style="width: 100%;">
                                    <el-option
                                      v-for="venue in venues"
                                      :key="venue.id"
                                      :label="venue.name"
                                       v-validate="'required'"
                                      :value="venue.id">
                                    </el-option>
                                    <span class="err-msg">{{ errors.first('venue') }}</span>
                                </el-select>                                
                              </div>
                               
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Start Date:<span class="req-text">*</span></label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <div class="row">
                                    <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <el-col :span="50">
                                            <el-date-picker
                                            type="date"
                                            :placeholder="getDatePlaceholder()"
                                            style="width: 100%;"
                                            v-validate="'required'"
                                            name="start"
                                            v-model="addJob.start"
                                            :format="getDisplayFormat()"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            >
                                            </el-date-picker>
                                            <span class="err-msg">{{ errors.first('start') }}</span>
                                          </el-col>
                                        </label>
                                        
                                    </div>
                                    <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                        <label class="common-label-text common-label-text--modalwidth">End Date:<span class="req-text">*</span></label>
                                    </div>
                                    <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <el-col :span="50">
                                            <el-date-picker
                                            type="date"
                                            :placeholder="getDatePlaceholder()"
                                            style="width: 100%;"
                                            v-validate="'required'"
                                            name="end"
                                            v-model="addJob.end"
                                            :format="getDisplayFormat()"
                                            :picker-options="pickerOptions"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            >
                                            </el-date-picker>
                                            <span class="err-msg">{{ errors.first('end') }}</span>
                                          </el-col>  
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                <!-- <vue-editor id="editor1" class="c-common-box-shadow c-radius3" v-model="addJob.employer_request" style="height: 220px;"></vue-editor> -->

                                <vue-editor 
                                    id="editor1" 
                                    class="c-common-box-shadow c-radius3" 
                                    :class="{ 'error-border': hasError }"
                                    v-model="addJob.employer_request" 
                                    style="height: 220px;"
                                    @text-change="validateContent('employer_requests', addJob.employer_request)"
                                ></vue-editor>
                                <span 
                                    v-if="error.employer_requests && error.employer_requests.hasError" 
                                    class="err-msg"
                                >
                                    {{ error.employer_requests.message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="modalType=='add'" class="row">
                      <div class="col-sm-12 o-modal-field-area">
                          <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                              <label class="common-label-text common-label-text--modalwidth">Documents:</label>
                          </div>
                          <div class="col-sm-8 o-left-no-padding o-modal-form-field no-right-padding">
                              <div v-for="(file, key) in new_files" :key ="key" class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                  <button class="btn c-common-btn c-common-btn--small">Choose File</button>
                                  <input @change="addFileForAddNewJob($event,key)" type="file" name="myfile" />
                                  <span class="addJobTypeArea">
                                      <span class="addJob-title">{{snippet(new_files[key].name)}}</span>
                                      <span v-if="file.selected == true" class="addJob-drop">
                                          <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop add-job-drop-type">
                                              <select v-model="new_files[key].label">
                                                  <option value="Report">Report</option>
                                                  <option value="HW">HW</option>
                                                  <option value="Other">Other</option>
                                              </select>
                                          </div>
                                      </span>
                                  </span>
                                  <a href="javascript: void(0)" v-if="new_files.length >1" @click="removeFile(key)" class="o-choose-del-btn">
                                      <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                  </a>
                              </div>
                          </div>
                          <div class="col-sm-1 o-right-no-padding o-modal-form-field o-job-add-icon">
                              <label class="common-label-text common-label-text--modalwidth">
                                  <a href="javascript: void(0)" @click="cloneInputfile()" class="o-choose-add-btn">
                                      <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                  </a>
                              </label>
                          </div>
                      </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeAddJob()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a href="javascript: void(0)" v-if="modalType=='add'" @click="addNewJob()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Job</a>
                            <a href="javascript: void(0)" v-if="modalType=='edit'" @click="editJob()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</a>
                        </li>
                    </ul>
                </div>
              </div>    
            </div>
          </div>
        </modal>
	</div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { VueEditor } from 'vue2-editor';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import { generateReportAsync } from '../../reportTaskPoller';

    export default {
        computed: {
            ...mapGetters({
               	userToken: 'userToken',
                userToken2: 'userToken2',
		        userRole: 'userRole',
		        companyId: 'companyId',
		        loginUserName: 'userName',
		        userID: 'userID',
		        userName: 'userName',
		        userFullName: 'userFullName',
                userRoleSlug: 'userRoleSlug'
            })
        },
        components: {
            VueEditor
        },
        data() {
            const dataProps = {
                globalBaseUrl: '',
                job:null,
                attachmentList:[],
                full_address_map:'',
                clients:{},
                modalLoading:false,
                modalDataLoad:false,
                modalType:'add',
                venues:[],
                addJob:{
                  title:'',
                  client:'',
                  payroll:'',
                  created_by:'',
                  start:'',
                  end:'',
                  employer_request:'',
                  employer_contact: '',
                  venue: ''
                },
                newJobId:'',
                validation_err: 0,
                
                files: [{
                    file: 'No file chosen'
                }, ],
                new_files:[
                    {
                        'name': 'No file chosen',
                        'selected': false,
                    }
                ],
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: new Date(dataProps.addJob.start).setDate(new Date(dataProps.addJob.start).getDate() - 1)
                    };
                },
                employer_users: [],
                hasError: false,
                error: {},

            }
            return dataProps;
        },
        created() {  
            this.globalBaseUrl = global[0].BASE_URL;       
            this.getJob();
        },
        methods: {
            displayEmployerContact(job){
                let employerContact = '';
                if(job.employer&&job.employer.employer_users&&job.employer.employer_users.length){
                    job.employer.employer_users.forEach((employerUser) => {
                        if(employerUser.user.id == job.employer_user_id) {
                            employerContact = ' ' +employerUser.user.first_name + ' ' + employerUser.user.last_name;
                        }
                    })
                }
                return employerContact;
            },

            getSkillById(id) {
            },

            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            deleteAccess(){
                if(this.job && this.job.calls && this.job.calls.length==0)
                    return true;
                return false;
            },
            getTimeUtc(dateTime) {
                return dateTimeConvert.timeFromUtc(dateTime);
            },
            getDateUtc(str) {
                return dateTimeConvert.dateFromUtc(str);
            },
            decodeFileId(id){
                return btoa(id);
            },
            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if (getAuthor.uploader_id == this.userId) {
                    return "Me";
                } else {
                    return getAuthor.uploaded_by;
                }
            },
            employeeDownload() {
                service.get('employee/employeeExport', {
                    'Authorization': this.userToken,
                    'jobId': atob(this.$route.params.id),
                    'ClientId': this.job.client_id
                }).
                then((res) => {
                    this.JSONToCSVConvertor(res.data.result, "Employee details", true);

                }).catch((err) => {
                    console.log(err);
                });
            },
            deleteJob() {
                this.$confirm('Current Job will be removed from the JOBS/EVENT. . Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('job/' + atob(this.$route.params.id) + '/delete', {}, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.job.client_id
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.$router.push({
                            path: `/jobList`
                        });
                    }).catch((err) => {
                        console.log(err);
                        this.$message({
                            type: 'error',
                            message: 'Error'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';
                CSV += ReportTitle + '\r\n\n';
                if (ShowLabel) {
                    var row = "";
                    for (var index in arrData[0]) {
                        row += index + ',';
                    }

                    row = row.slice(0, -1);
                    CSV += row + '\r\n';
                }

                for (var i = 0; i < arrData.length; i++) {
                    var row = "";
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }

                    row.slice(0, row.length - 1);
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                var fileName = "Job_";
                fileName += ReportTitle.replace(/ /g, "_");

                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
                var link = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },

            goSignInSheet() {
                this.$router.push({
                    path: `/employerSignInSheet/`+ this.$route.params.id
                });
            },

            async gcsSignInSheet(){
                this.loading = true;
                try {
                    const task = await generateReportAsync('signin_sheet', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.job.client_id,
                    }, { job_id: atob(this.$route.params.id) });
                    this.loading = false;
                    let data_source = task.gcs_path;
                    let sign_in_sheet_url = this.job?.client?.gcs_signin_sheet_template ?? '';
                    let redirectUrl = dateTimeConvert.getEmployerSignInSheetUrl('jobReports/', sign_in_sheet_url, data_source);
                    redirectUrl = redirectUrl + '&token=' + btoa(this.userToken2) + "&job=" + this.$route.params.id + "&api_base_url=" + btoa(global[0].BASE_URL);
                    window.open(redirectUrl, "_blank");
                } catch (err) {
                    this.loading = false;
                    this.$notify.error({ title: 'Error', message: err.message || 'Failed to generate report' });
                }
            },

            goToCalls(){
                this.$router.push({
                    path: `/viewCallsEmployer/` + this.$route.params.id
                });
            },

            closeAddJob() {
                this.$modal.hide("add-job");
            },

            async addNewJob(){
                this.validateContent('employer_requests', this.addJob.employer_request);
                await this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return; // Stop the save process
                    }
                    let fromData = {
                        title: this.addJob.title,
                        client_id: this.addJob.client,
                        payroll_id: this.addJob.payroll,
                        start: this.addJob.start,
                        end: this.addJob.end,
                        employer_requests: this.addJob.employer_request,
                        created_by: this.addJob.created_by,
                    };
                    service.post('employerjob', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                    }).then((res) => {
                        this.newJobId=res.data.result.id;
                        this.uploadImage();
                        this.$modal.hide("add-job");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Job Added Successfully.',
                            type: 'success'
                        });
                        this.getJob(this.selectedTab);
                    }).catch((err) => {
                        console.log(err);
                    });
                }else{
                  console.log('error');
                }
              });
            },

            async addEmployerContact(id) {
                await service.get('employer/'+id+'/getAllEmployerUsersListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                   
                    let self =this;
                    this.employer_users=res.data.result.employer_users;
                    this.employer_users.forEach(function(user) {
                        if(user.user_id == self.addJob.employer_contact){
                            self.addJob.employer_contact = user.user.id;
                        }
                    });
                }).catch((err) => {
                    console.log(err);
                })
            },

            getEmployerFullName(user) {
                return user.first_name + ' ' + user.last_name
            },

            async openAddJob() {
                this.modalDataLoad = true;
                this.modalType='add';
                this.$modal.show("add-job");
                this.modalLoading=true;

                this.addJob.created_by=this.userID;
                await service.get('getVenuesList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId
                })
                .then((venues) => {
                     let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                });
                await service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                })
                .then((res) => {
                    this.clients = res.data.result;
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                });
                await this.addEmployerContact(this.companyId);               

            },

            editJob(){
                this.validateContent('employer_requests', this.addJob.employer_request);
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.hasValidationErrors()) {
                            this.$notify.error({
                                title: 'Error', 
                                message:'Please fix validation errors before saving.'}
                            ); 
                            return; // Stop the save process
                        }
                        let fromData = {
                            title: this.addJob.title,
                            client_id: this.addJob.client,
                            payroll_id: this.addJob.payroll,
                            start: this.addJob.start,
                            end: this.addJob.end,
                            employer_requests: this.addJob.employer_request,
                            created_by: this.addJob.created_by,
                            employer_contact: this.addJob.employer_contact
                        };

                        if(this.addJob.venue&&this.addJob.venue!='') {
                            fromData.venue_id = this.addJob.venue
                        }

                        service.put('employerjob/'+this.editJobId, fromData, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'employer-id': this.companyId,
                        }).then((res) => {
                            this.$modal.hide("add-job");
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Job Updated Successfully.',
                                type: 'success'
                            });
                            this.getJob(this.selectedTab);
                    }).catch((err) => {
                        console.log(err);
                    });
                    }else{
                        console.log('error');
                    }
              });    
            },

            async getDropdownVenues() {
                if(this.userRoleSlug == 'employer' || this.userRoleSlug == 'employer-admin') {
                    this.modalDataLoad = true;
                    await service.get('getVenuesList', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'employer-id': this.companyId,
                        'cs3-context-clientId': this.addJob.client
                    })
                    .then((venues) => {
                        this.modalDataLoad = faalse;
                        let resVenues = venues.data.result;
                        let venuesList = [];
                        resVenues.forEach((obj) => {
                            if(obj.addresses&&obj.addresses.length) {
                                venuesList.push(obj);
                            }
                        })
                        this.venues = venuesList;
                    }).catch((err) => {
                        this.modalDataLoad = true;
                        console.log(err);
                    });
                }
            },

            async openEditJob() {
                this.modalDataLoad = true;
                var job=this.job;
                this.modalType='edit';
                this.$modal.show("add-job");
                this.editJobId=job.id;
                this.addJob.title=job.title;
                this.addJob.client=job.client_id;
                this.addJob.payroll='';
                this.addJob.start=job.start;
                this.addJob.end=job.end;
                this.addJob.employer_request=job.employer_requests;
                this.modalLoading=true;
                this.modalDataLoad=true;
                if(job.venue_id&&job.venue_id!='') {
                    this.addJob.venue=job.venue_id;
                }
                await service.get('getVenuesList', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId,
                    'cs3-context-clientId': this.addJob.client
                })
                .then((venues) => {
                    let resVenues = venues.data.result;
                    let venuesList = [];
                    resVenues.forEach((obj) => {
                        if(obj.addresses&&obj.addresses.length) {
                            venuesList.push(obj);
                        }
                    })
                    this.venues = venuesList;
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                });
                await service.get('employer/'+this.companyId+'/getEmployerClientAssociation', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                })
                .then((res) => {
                    this.clients = res.data.result;
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalLoading=false;
                    this.modalDataLoad=false;
                });
                await this.addEmployerContact(this.companyId);
                this.modalLoading=false;
                this.modalDataLoad=false;
            },
            addFileForAddNewJob(e, index) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2000000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files[index].img = img
                            this.new_files[index].name = input.files[0].name,
                            this.new_files[index].status = true; 
                            this.new_files[index].uploading = false;
                            this.new_files[index].uploaded = false;
                            this.new_files[index].path = '';
                            this.new_files[index].label = 'Report';
                            this.new_files[index].type = type[0];
                            this.new_files[index].fileExtension = this.setPicture(type[0]);
                            this.new_files[index].selected = true;
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },

            uploadImage() {
                for (var i = 0; i < this.new_files.length; i++) {
                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false && this.new_files[i].selected==true) {
                        this.uploadService(this.new_files[i]).then((path) => {
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
            },

            uploadService(img) {
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name

                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'employer-id': this.companyId
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.uploaded = true;

                            let activityData = {
                                uploader_id: this.userID,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.newJobId,
                                created_by: this.userID,
                                attachable_type: 'job',
                                filename: img.name,
                                description: 'Job Document',
                                label: img.label,
                                path: img.path,
                                activity: JSON.stringify(activityData)
                            }
                            service.post('attachment', fromData, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'employer-id': this.companyId
                            })
                            .then((res) => {
                            }).catch((err) => {
                                 console.log('Error');
                            });

                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;
            },

            cloneInputfile() {
                this.new_files.push({
                    'name': 'No file chosen',
                    'selected': false,
                });
            },

            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },

            removeFile(key) {
                this.new_files.splice(key, 1);
            },

            snippet(value) {
                if (value.length > 15)
                    return value.slice(0, 15) + '  ...';
                else
                    return value;
            },

            getJob(){
                service.get('employerjob/'+atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId,
                  })
                  .then((res) => {
                    this.job=res.data.result;
                    this.attachmentList=res.data.result.attachments;
                    this.addJob.employer_contact = this.job.employer_user_id;
                    this.addJob.created_by = this.job.created_by.id;
                    let venue =this.job.venue;
					if(venue && venue.addresses && venue.addresses.length){
						this.full_address_map =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
					}
                  }).catch((err) => {
                    console.log(err);
                    this.afterAPI = true;
                    this.loading = false;
                  })
            },

            getDate(str) {
                return dateTimeConvert.localDate(str);
            },

            getUserDateTimeFormat(jobDateTime) {
                return dateTimeConvert.getUserDateTime(jobDateTime,this.userDateFormat,this.userTimeFormat);
            },

            validateContent(fieldName, value) {
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    if (this.containsInvalidContent(plainText)) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            message: 'Content contains invalid text. Please review and correct.'
                        });
                    }
                }
            },
    
            getPlainText(html) {
                // Remove HTML tags and get plain text
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent || div.innerText || '';
            },
    
            containsInvalidContent(text) {
                                
                // Example 1: Check for script tags or malicious content
                const scriptPattern = /<script|javascript:|onerror=|onclick=/i;
                
                // Example 2: Check for excessive special characters
                const excessiveSpecialChars = /[.?!,#$^&*()@%|"':;<>]{3,}/;
                
                // Example 3: Check for spam-like patterns (multiple repeated characters)
                const spamPattern = /(.)\1{3,}/;
                
                // Example 4: Check for invalid URLs or suspicious links
                const suspiciousUrl = /bit\.ly|tinyurl|goo\.gl/i;
                
                // Return true if any invalid pattern is found
                return scriptPattern.test(text) || 
                excessiveSpecialChars.test(text) || 
                spamPattern.test(text) ||
                suspiciousUrl.test(text);
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
            
        },
        mounted() {
            var sidenavWidth = $(".mainSidenav").width();
            var windowWidth = $(window).width();
            $(".o-header").css('width', windowWidth - sidenavWidth);
        }
    }

</script>
<style>
.err-msg {
    margin: 2px;
    color: red
}
#add-call span.ps1 ul {
    list-style: disc;
    padding: 15px;
}
#add-call span.ps1 ul li {
    list-style-type: disc;
}

#add-call span.ps1 ol {
    list-style: decimal;
    padding: 15px;
}
#add-call span.ps1 ol li {
    list-style-type: decimal;    
}
</style>
